// import { memo } from "react";
import ImgLoader from "../Images/icons8-coffee-cup.gif";
import "../styles/loader.css"
export const Loader = () => {
    return <>
        <div className="containerLoader" >
            <img src={ ImgLoader } alt="" srcset="" />
        </div>
    </>;
}